import { render, staticRenderFns } from "./Combo.vue?vue&type=template&id=f8e86ae0&"
import script from "./Combo.vue?vue&type=script&lang=ts&"
export * from "./Combo.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports